const mixinLocation = {
  data() {
    return {
      center: {},
    };
  },
  methods: {
    getPosition() {
      return new Promise((resolve, reject) => {
        try {
          if (!localStorage.getItem('location')) {
            const vueThis = this;
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
                function (position) {
                  const locationData = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    alt: position.coords.altitude,
                  };
                  localStorage.setItem(
                    'location',
                    JSON.stringify(locationData)
                  );
                  vueThis.center.lat = position.coords.latitude;
                  vueThis.center.lng = position.coords.longitude;
                  vueThis.center.alt = position.coords.altitude;
                  resolve(locationData);
                },
                function (error) {
                  if (error.code == error.PERMISSION_DENIED) {
                    const locationData = {
                      lat: 11.24079,
                      lng: -74.19904,
                      alt: null,
                    };
                    vueThis.center = { ...locationData };
                    resolve(locationData);
                  }
                }
              );
            } else {
              const locationData = {
                lat: 11.24079,
                lng: -74.19904,
                alt: null,
              };
              vueThis.center = { ...locationData };
              resolve(locationData);
            }
          } else {
            const locationData = JSON.parse(localStorage.getItem('location'));
            this.center.lat = locationData.lat;
            this.center.lng = locationData.lng;
            this.center.alt = locationData.alt;
            resolve(locationData);
          }
        } catch (error) {
          console.log(error);
          reject(new Error('No se pudo obtener posición'));
        }
      });
    },
  },
};

export default mixinLocation;
